<template>
  <div>
    <!-- 操作按钮取 -->
    <div class="btns-bar">
      <el-button type="primary" @click="openAddDialog">添加广告位</el-button>
    </div>
    <!-- 表格展示 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="_id" label="广告ID" width="220">
        <template slot-scope="scope">
          <copy-text :value="scope.row._id"></copy-text>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="广告标题"
        min-width="200"
      ></el-table-column>
      <el-table-column prop="url" label="链接" width="180"></el-table-column>
      <el-table-column label="图片" width="300">
        <template slot-scope="scope">
          <el-image
            style="width: 120px; height: 50px"
            :src="scope.row.img"
            :preview-src-list="[scope.row.img]"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="顺序" width="300">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.order" :min="1" :max="100" size="small"></el-input-number>
          <el-button type="primary" size="small" class="order-save-btn" @click="saveOrder(scope.row._id, scope.row.order)">保存</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" :width="isMobile ? 64 : 120" fixed="right">
        <template slot-scope="scope">
          <div class="table-actions">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="openEditDialog(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDelete(scope.row._id)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加/修改对话框 -->
    <el-dialog
      v-loading="uploading"
      :title="isEdit ? '修改广告位' : '添加广告位'"
      :visible.sync="showDialog"
      width="30%"
      custom-class="mobile-form-dialog"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <event-link-autocomplete v-model="form.url"></event-link-autocomplete>
          <div class="url-hint">
            支持以下格式：<br/>
            1. 小程序页面路径（带 / 开头）：<span class="url-example">/pages/brandDetail/brandDetail?value=huanji</span><br/>
            2. 微信公众号文章链接：<span class="url-example">https://mp.weixin.qq.com/s/xxx</span><br/>
            3. 赛事ID（直接填写，跳转赛事详情）：<span class="url-example">65a0f3ed8e443fe4d49aff9c</span>
          </div>
        </el-form-item>
        <el-form-item label="图片链接" prop="img">
          <el-upload
            class="image-upload"
            action=""
            :http-request="onUploadPoster"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgPreviewDialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <el-input v-model="form.img"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import uploadMixin from "../../mixin/upload";
import EventLinkAutocomplete from "../../components/EventLinkAutocomplete.vue";

export default {
  components: {
    EventLinkAutocomplete
  },
  data() {
    return {
      showDialog: false,
      isEdit: false,
      editId: null,
      tableData: [],
      form: {
        title: "",
        url: "",
        img: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入广告标题", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        img: [
          { required: true, message: "请输入广告图片URL", trigger: "blur" },
          {
            min: 3,
            max: 500,
            message: "长度在 3 到 500 个字符",
            trigger: "blur",
          },
        ],
      },
      uploading: false,
      fileList: [],
      isMobile: false
    };
  },
  mixins: [uploadMixin],
  created() {
    this.getAdsList();
  },
  mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },
  methods: {
    updateViewport() {
      this.isMobile = window.innerWidth <= 768;
    },
    getAdsList() {
      this.$axios
        .get("/ads/find_all")
        .then((res) => {
          this.tableData = res.data.res;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    openAddDialog() {
      this.isEdit = false;
      this.editId = null;
      this.form = {
        title: "",
        url: "",
        img: "",
      };
      this.fileList = [];
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.editId = row._id;
      this.form = {
        title: row.title,
        url: row.url || "",
        img: row.img,
      };
      this.fileList = row.img ? [{ url: row.img }] : [];
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return this.$message.error("表单信息填写错误，请根据提示检查！");
        }
        if (this.isEdit) {
          this.updateAd();
        } else {
          this.addAd();
        }
      });
    },
    addAd() {
      this.$axios
        .post("/ads/add", JSON.stringify(this.form), {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.data.code === "success") {
            this.$message.success("添加成功！");
            this.showDialog = false;
            this.getAdsList();
          } else {
            this.$message.error("请求错误！");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    updateAd() {
      this.$axios
        .post("/ads/update", JSON.stringify({ id: this.editId, ...this.form }), {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.data.res && res.data.res._id) {
            this.$message.success("修改成功！");
            this.showDialog = false;
            this.getAdsList();
          } else {
            this.$message.error("请求错误！");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    handleDelete(id) {
      this.$confirm("此操作将永久删除该广告位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.requestDelete(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    requestDelete(id) {
      this.$axios
        .post("/ads/delete", JSON.stringify({ id: id }), {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.data.code === "success") {
            this.$message.success("删除成功");
            this.getAdsList();
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
          if (err.response.data.code === "token_timeout") {
            this.$message.error("登录过期，请重新登录！");
          }
        });
    },
    onUploadPoster(param) {
      this.uploading = true;
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.form.img =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.uploading = false;
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.uploading = false;
          this.$message.error("上传失败");
        }
      });
    },
    saveOrder(_id, order) {
      if (!_id) {
        return this.$message.error("顺序不能为空！");
      }
      this.$axios
        .post("/ads/update_order", JSON.stringify({
          _id,
          order
        }), {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.data.code === "success") {
            this.$message.success("更新成功！");
          } else {
            this.$message.error("请求错误！");
          }
          this.getAdsList();
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    }
  },
};
</script>

<style scoped>
.btns-bar {
  margin: 20px 0;
}
.image-upload {
  margin-bottom: 10px;
}
.order-save-btn {
  margin-left: 10px;
}
.url-hint {
  font-size: 12px;
  color: var(--text-secondary, #909399);
  line-height: 1.8;
  margin-top: 6px;
}
.url-example {
  color: var(--brand-primary, #c04851);
  font-family: 'Courier New', Courier, monospace;
  background-color: var(--bg-table-hover, #f5f7fa);
  padding: 1px 6px;
  border-radius: 3px;
}
.table-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.table-actions .el-button {
  margin: 0;
}

@media (max-width: 768px) {
  .table-actions {
    flex-direction: column;
    align-items: center;
  }
}
</style>
